import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Inject, Injectable } from '@angular/core';
import { Observable, tap, throwError } from 'rxjs';
import { ENDPOINTS, FedExRequest, LocationEntry, LocationSearchResponse } from '@evorait/pace-core';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { EnvironmentService } from '@evorait/pace-environment';

@Injectable({ providedIn: 'root' })
export class MaterialFedexLocationService {
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly httpClient: HttpClient,
        private readonly environmentService: EnvironmentService,
    ) {}

    /**
     * Retrieves list of nearby FedEx locations for delivery
     *
     * @param request the request containing the address close to which we want to perform the FedEx search
     * @returns Observable containing the list of FedEx locations nearby
     */
    public getFedexLocations(request: FedExRequest): Observable<LocationEntry[]> {
        this.log.info(`MaterialFedexLocationService: getFedexLocations: request payload: ${JSON.stringify(request)}`);

        const url = `${this.environmentService.apiBase}${ENDPOINTS.GetFedexLocations}`;

        return this.httpClient.post<LocationSearchResponse>(url, request).pipe(
            tap((res) => this.log.info(`FedEx locations retrieved: ${res.DataCollection?.length ?? 0}`)),
            map((res) => res.DataCollection || []),
            catchError((error) => {
                this.log.error('FedEx location API call failed:', error);
                return throwError(() => error);
            }),
        );
    }
}
